import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/shared-module/seguridad/services/auth.guard';
import { EmpresasEmpComponent } from './views/administrador/empresas/empresas.component';
import { CrearEmpleadoComponent } from './views/administrador/ce-empleado/ce-empleado.component';
import { HomeEmpComponent } from './views/administrador/home-emp/home-emp.component';
import { ReportesComponent } from './views/administrador/reportes/reportes.component';
import { CrearCargosComponent } from './views/administrador/crear-cargos/crear-cargos.component';
import { ReportesEmpComponent } from './views/administrador/reportes-emp/reportes-emp.component';
import { UploadEmpleadoComponent } from './views/administrador/upload-empleado/upload-empleado.component';
import { ControlEmpresaComponent } from './views/administrador/control-empresa/control-empresa.component';
import { EliminarEmpleadoComponent } from './views/administrador/eliminar-empleado/eliminar-empleado.component';
import { CrearHistorialComponent } from './views/administrador/crear-historial/crear-historial.component';
import { HomeSstmaComponent } from './views/sstma/home-sstma/home-sstma.component';
import { RechazadosDocumentacionComponent } from './views/sstma/rechazados-documentacion/rechazados-documentacion.component';
import { AprRechDocumentacionComponent } from './views/sstma/apr-rech-documentacion/apr-rech-documentacion.component';
import { ReporteHorasComponent } from './views/administrador/reporte-horas/reporte-horas.component';
import { AprobadosDocumentacionComponent } from './views/sstma/aprobados-documentacion/aprobados-documentacion.component';
import { DesvinculacionComponent } from './views/administrador/desvinculacion/desvinculacion.component';
import { MantenerMarcacionesComponent } from './views/administrador/mantener-marcaciones/mantener-marcaciones.component';
import { SeguridadComponent } from './garita/seguridad/seguridad.component';
import { ConfirmacionComponent } from './garita/confirmacion/confirmacion.component';





const eppRoutes: Routes = [
  //sesion administrador
  { path: 'emp/administrador/home-emp', component: HomeEmpComponent},// canActivate: [AuthGuard] },
  { path: 'emp/administrador/empresas', component: EmpresasEmpComponent},// canActivate: [AuthGuard] },
  { path: 'emp/administrador/cargos', component: CrearCargosComponent},// canActivate: [AuthGuard] },
  { path: 'emp/administrador/matn-marcacion', component: MantenerMarcacionesComponent},// canActivate: [AuthGuard] },
  { path: 'emp/administrador/empleados', component: CrearEmpleadoComponent},// canActivate: [AuthGuard] },
  { path: 'emp/administrador/reporte', component: ReportesComponent},// canActivate: [AuthGuard] },
  { path: 'emp/administrador/reporte-emp', component: ReportesEmpComponent},// canActivate: [AuthGuard] },
  { path: 'emp/administrador/reporte-horas', component: ReporteHorasComponent},// canActivate: [AuthGuard] },
  { path: 'emp/administrador/upload-emp', component: UploadEmpleadoComponent},// canActivate: [AuthGuard] },
  { path: 'emp/administrador/control-empresa', component: ControlEmpresaComponent},// canActivate: [AuthGuard] },
  { path: 'emp/administrador/eliminar-empleado', component: EliminarEmpleadoComponent},// canActivate: [AuthGuard] },
  { path: 'emp/administrador/crear-historial', component: CrearHistorialComponent},// canActivate: [AuthGuard] },
  //EN CONSTRUCCION
  { path: 'emp/administrador/desvinculacion-contratista', component: DesvinculacionComponent},// canActivate: [AuthGuard] },

  //SSTMA
  { path: 'emp/sstma/home', component: HomeSstmaComponent},// canActivate: [AuthGuard] },
  { path: 'emp/sstma/rechazados', component: RechazadosDocumentacionComponent},// canActivate: [AuthGuard] },
  { path: 'emp/sstma/documentacion', component: AprRechDocumentacionComponent},// canActivate: [AuthGuard] },
  { path: 'emp/sstma/aprobados', component: AprobadosDocumentacionComponent},// canActivate: [AuthGuard] }
  //sesion punto de venta 

  //VERIFICACIONES GARITA
  { path: 'garita', component: SeguridadComponent},
  { path: 'verificacion', component: ConfirmacionComponent},

];

@NgModule({
  imports: [RouterModule.forChild(eppRoutes)],
  exports: [RouterModule]
})
export class EmpTercerosRoutingModule { }
